// Zoom levels, in percent, that the PDF viewer steps through.
export const PDF_ZOOMS = [100, 150, 200, 300, 400];

export function mediaType(media = {}) {
  const mime = String(media.mime_type || media.mime || media.content_type || "").toLowerCase();
  const extensions = [media.url || media.src, media.file_name || media.display_name]
    .map(value => String(value || "").split(/[?#]/)[0].match(/\.([a-z0-9]+)$/i)?.[1]?.toLowerCase())
    .filter(Boolean);
  if (mime.startsWith("application/pdf") || extensions.includes("pdf") || media.type === "pdf") return "pdf";
  if (mime.startsWith("video/") || extensions.some(extension => ["mp4", "mov", "webm", "mkv"].includes(extension)) || media.type === "video") return "video";
  return "image";
}

export function gallerySlide(media) {
  const type = mediaType(media);
  const src = media.url || media.src;
  const caption = {
    ...(media.action || media.display_name ? { title: media.action || media.display_name } : {}),
    ...(media.remark ? { description: media.remark } : {}),
  };
  if (type === "video") {
    const extension = String(src || "").split(/[?#]/)[0].split(".").pop().toLowerCase();
    const mime = media.mime_type || ({ webm: "video/webm", mov: "video/quicktime", mkv: "video/x-matroska" }[extension]) || "video/mp4";
    return { type, width: 1280, height: 720, sources: [{ src, type: mime }], ...caption };
  }
  // The file storage host sends no cross-origin header, so a script cannot
  // read a PDF from it and the in-page viewer fails. The API serves the same
  // file with that header; the storage link stays for opening in a new tab.
  if (type === "pdf" && media.api_url) {
    return { type, src, previewSrc: media.api_url, ...caption };
  }
  return { type, src, ...caption };
}

export function reportMedia(product, key) {
  const files = [
    ...(Array.isArray(product?.[key]) ? product[key] : []),
    ...(product?.media || []).filter(media => media.collection_type === key),
  ].map(file => typeof file === "string" ? { url: file } : { ...file, url: file?.url || file?.original_url || file?.file_url || file?.full_url || file?.path });
  return files.filter((file, index) => file?.url && files.findIndex(other => other?.url === file.url) === index);
}
